import { css } from '@emotion/core'

const BREAKPOINTS = [['XS', 370], ['S', 450], ['M', 769], ['L', 1440]]

// sample return size val => (min-width: 768px)
export const MATCH_MEDIA = BREAKPOINTS.reduce(
	(acc, bp) => ({
		...acc,
		[bp[0]]: `(min-width: ${bp[1]}px)`,
	}),
	{}
)

// sample return size val => @media (min-width: 768px)
export const MQ = BREAKPOINTS.reduce(
	(acc, bp) => ({
		...acc,
		[bp[0]]: `@media ${MATCH_MEDIA[bp[0]]}`,
	}),
	{}
)

export const MIN_HEIGHTS = {
	XS: '710px',
	SM: '920px',
	MD: '950px',
}

export const SPACERS = {
	S: '5px',
	M: '10px',
	L: '15px',
	XL: '20px',
}

// font sizes in comments below are calculated from 16px base font-size
export const FONT_SIZES = {
	H1: '2rem', // 32px
	H2: '1.68179rem', // ~27px
	H3: '1.41421rem', // ~23px
	H4: '1.12246rem', // ~18px
	H5: '0.8909rem', // ~14px
	H6: '0.7937rem', // ~13px
}

export const COLORS = {
	BLACK: '#000',
	BLACK_TEXT: '#323232',
	BLUE_LIGHT: '#3da4e3',
	GRAY_FOOTER: '#e6e6e6',
	WHITE: '#FFF',
}

// rfq app
export const MIN_RFQ_HEIGHT = '560px'
export const MAX_RFQ_WIDTH = {
	S: '360px', // 32px
	M: '740px',
	L: '800px',
}

const MAX_SECTION_WIDTH = '800px'
export const sectionWrapStyling = css`
	margin-left: auto;
	margin-right: auto;
	max-width: ${MAX_SECTION_WIDTH};
`
